module.exports = __webpack_public_path__ + "static/l5-cd72c3f73e2bbafc6faf4bfce0ebcacb.png";